var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.667 0a2.667 2.667 0 0 1 2.661 2.498l.005.169v.888h3.556A.889.889 0 0 1 17 5.327l-.111.007h-.89L16 16.889a2.667 2.667 0 0 1-2.498 2.661l-.169.006H4.444a2.667 2.667 0 0 1-2.661-2.498l-.005-.17-.001-11.555H.889a.889.889 0 0 1-.112-1.77l.112-.007 3.555-.001v-.888A2.667 2.667 0 0 1 6.942.005L7.112 0h3.555zM3.555 5.333v11.556c0 .453.34.827.778.882l.111.007h8.89a.89.89 0 0 0 .881-.778l.007-.111V5.333H3.555zm7.112-3.555H7.11a.89.89 0 0 0-.882.777l-.007.112v.888h5.333v-.888a.89.89 0 0 0-.777-.882l-.111-.007z",
    fill: "#EE4F4F",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRed);
export default __webpack_public_path__ + "static/media/delete-red.876017f9b37ee0c3193ac47d67198d95.svg";
export { ForwardRef as ReactComponent };